export enum TrackingEvent {
  ModalLoaded = `immersive-modal-opened`,
  CloseModal = `immersive-modal-closed`,
  MobileModalLoaded = `mobile-immersive-modal-opened`,
  MobileCloseModal = `mobile-immersive-modal-closed`,
  StepClick = `sidebar-step-click`,
  WelcomeResourceClick = `welcome-resource-click`,
  InviteTeammate = `invite-teammate`,
  AutocaptureDocsSource = `immersive-onboarding--autocapture-docs`,
  StartWithSDKClick = `start-with-sdk-click`,
  StartWithExistingToolClick = `start-with-existing-tool-click`,
  SelectAlternateSDKClick = `select-alternate-sdk-click`,
  ReturnToStart = `return-to-start-click`,
  VerifyConnection = `verify-connection-click`,
  ToggleAutocapture = `toggle-autocapture-click`,
  ToggleSessionReplay = `toggle-session-replay-click`,
  TokenCopied = `token-copied`,
  LinkClicked = `link-clicked`,
  LearnMixpanelVideoClick = `learn-mixpanel-video-click`,
  ViewDemoProject = `view-demo-project`,
  ChooseWhichMethodClick = `choose-which-method-doc-click`,
  JavascriptDocLink = `javascript-doc-link`,
  PythonDocLink = `python-doc-link`,
  SwiftDocLink = `swift-doc-link`,
  NodeDocLink = `node-doc-link`,
  ReactNativeDocLink = `react-native-doc-link`,
  MoreSdksDocLink = `more-sdks-doc-link`,
  SegmentDocLink = `segment-doc-link`,
  BigQueryDocLink = `bigquery-doc-link`,
  SnowflakeDocLink = `snowflake-doc-link`,
  RudderStackDocLink = `rudderstack-doc-link`,
  RedshiftDocLink = `redshift-doc-link`,
  AutocaptureDocLink = `autocapture-doc-link`,
  SessionReplayDocLink = `session-replay-doc-link`,
  ContactSupportLink = `contact-support-link`,
  SuccessfulIntegration = `successful-integration`,
  PartialIntegration = `partial-integration`,
  FailedFetch = `failed-fetch`,
  VerifiedBoxDocLinkClick = `verified-box-doc-link-click`,
  ApiEvent = `api-event`,
  TabChanged = `tab-changed`,
  NpmTabClick = `npm-tab-click`,
  YarnTabClick = `yarn-tab-click`,
  RetryClicked = `retry-clicked`,
  SnippetLinkClick = `snippet-link-click`,
  AIInstallClick = `ai-tab-click`,
  SnippetCopied = `snippet-copied`,
  TallyIconClicked = `tally-icon-clicked`,
}

export enum TrackingProperty {
  Source = `source`,
  StepName = `step-name`,
  CurrentStep = `current-step`,
  Name = `name`,
  LinkSource = `link-source`,
  ApiResponse = `api-response`,
  TabName = `tab-name`,
  TallyIndicator = `tally-indicator`,
}

/**
 * Track an event in the setup process
 */
export const trackOnboardingEvent = (
  eventName: TrackingEvent,
  eventData?: {[key in TrackingProperty]?: string | number | boolean},
) => {
  const trackingData = {
    [TrackingProperty.Source]: TrackingEvent.AutocaptureDocsSource,
    ...eventData,
  };
  mixpanel.track(`[Immersive Onboarding] ${eventName}`, trackingData);
};
